<template>
    <div class="consult-container">
        <ComDetail :detail="detail" :detailCols="detailCols" :onCancel="onCancel"></ComDetail>
        <div class="search-container">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="应用名称">
                    <el-input v-model="formInline.appName" placeholder="请输入应用名称"></el-input>
                </el-form-item>
                <el-form-item label="应用类型">
                    <el-select v-model="formInline.type" placeholder="请选择" clearable>
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
            <!-- <el-button type="primary" @click="onAdd">新增</el-button> -->
        </div>
        <div class="table-container">
            <el-table v-loading="tableLoading" :data="tableData" :pagination="pagination" border style="width: 100%">
                <el-table-column prop="appName" label="应用名称" align="center">
                </el-table-column>
                <el-table-column prop="createDate" label="申请时间" align="center" :formatter="dateFormat">
                </el-table-column>
                <el-table-column prop="appType" align="center" label="应用类型">
                    <template slot-scope="scope">
                        <span>{{ scope.row.appType ? options.find(it => it.value === scope.row.appType).label :
                            '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="serverName" align="center" label="服务商">
                </el-table-column>
                <el-table-column prop="appCount" align="center" label="已开通">
                </el-table-column>
                <el-table-column prop="status" align="center" label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 0">已上架</span>
                        <span v-else-if="scope.row.status === 1">已下架</span>
                        <span v-else>未知状态</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="120">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="text" size="small" class="mr-10">查看</el-button>
                        <el-popconfirm :title="scope.row.status === 0 ? '确定要下架吗?' : '确定要上架吗?'"
                            @confirm="handleStartOrStop(scope.row)">
                            <el-button slot="reference" class="mx-10" type="text" size="small">{{ scope.row.status === 0
                                ? '下架' : '上架' }}</el-button>
                        </el-popconfirm>
                        <el-popconfirm title="确定要删除吗？" @confirm="handleDelete(scope.row)">
                            <el-button slot="reference" type="text" size="small">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]"
                    :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total">
                </el-pagination>
            </div>
        </div>
        <!-- 新增应用 -->
        <el-drawer title="新增应用" :visible.sync="drawer" direction="rtl" :before-close="cancelForm" size="50%"
            wrapperClosable="false" destroy-on-close="true">
            <el-form ref="form" :model="drawerForm" label-width="130px" :rules="rules">
                <el-form-item label="应用名称" prop="appName">
                    <el-input v-model="drawerForm.appName" placeholder="请输入应用名称"></el-input>
                </el-form-item>
                <el-form-item label="应用图标" prop="imgUrl" class="app-icon">
                    <el-radio v-for="item in iconList" :key="item" :label="item" v-model="drawerForm.imgUrl" border>
                        <img :src="item" alt="" style="width: 50px; height: 50px;">
                    </el-radio>
                </el-form-item>
                <el-form-item label="应用类型" prop="appType">
                    <el-select v-model="drawerForm.appType" placeholder="请选择应用类型" style="width: 100%;">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">{{
                            item.label }}</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="应用地址" prop="appUrl">
                    <el-input v-model="drawerForm.appUrl" placeholder="请输入应用地址"></el-input>
                </el-form-item>
                <el-form-item label="应用简介" prop="appDescribe">
                    <el-input rows="4" type="textarea" v-model="drawerForm.appDescribe"
                        placeholder="请输入应用简介"></el-input>
                </el-form-item>
                <el-form-item label="应用价格（元）" prop="appPrice">
                    <el-input v-model="drawerForm.appPrice" placeholder="请输入应用价格（元）"></el-input>
                </el-form-item>
                <el-form-item label="开通时长" prop="openDate">
                    <el-select v-model="drawerForm.openDate" placeholder="请选择开通时长" style="width: 100%;">
                        <el-option v-for="item in openTimeDict" :key="item.value" :label="item.label"
                            :value="item.value">{{
                                item.label }}</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="试用时长" prop="tryTime">
                    <el-select v-model="drawerForm.tryTime" placeholder="请选择试用时长" style="width: 100%;">
                        <el-option v-for="item in trialTimeDict" :key="item.value" :label="item.label"
                            :value="item.value">{{
                                item.label }}</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="应用详情">
                    <div style="border: 1px solid #ccc;">
                        <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig"
                            :mode="mode" />
                        <Editor style="height: 300px; overflow-y: hidden;" v-model="html" :defaultConfig="editorConfig"
                            :mode="mode" @onCreated="onCreated" />
                    </div>
                </el-form-item>
            </el-form>

            <div class="drawer-footer">
                <el-button @click="cancelForm()">取 消</el-button>
                <el-button type="primary" @click="submitAdd('form')" :loading="loading">{{ loading ? '提交中 ...' : '确 定'
                    }}</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { getAppInfoList, getAppInfoOn, getAppInfoOff, getAppInfoDel, getAddApp, getAppIconList, getAppInfoDetail } from '@/api/SupermarketOperation'
import moment from "moment";
import ComDetail from '@/components/common/comDetail.vue';
import { appTypeDict, appTypeDict2, openTimeDict, trialTimeDict, openVersionDict, payStatusDict } from '@/data/constant'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
    name: 'AdminStaticsMessage',
    components: {
        ComDetail,
        Editor,
        Toolbar
    },
    data() {
        return {
            tableLoading: false,
            editor: null,
            loading: false,
            html: '',
            toolbarConfig: {},
            editorConfig: {
                placeholder: '请输入内容...',
                MENU_CONF: {
                    uploadImage: {
                        server: '',
                        fieldName: 'file',
                        base64LimitSize: 10 * 1024 * 1024, // 10M
                        maxNumberOfFiles: 5,
                        allowedFileTypes: ['image/*'],
                        onSuccess(file, resData) {
                            console.log(resData)
                        },
                        onFailed(file, resData, res) {
                            console.log(resData)
                        },
                        onError(file, err, res) {
                            console.log(err, res)
                        },
                    },
                }
            },
            mode: 'default', // or 'simple'
            appTypeDict,
            openTimeDict,
            trialTimeDict,
            drawer: false,
            iconList: [],
            drawerForm: {
                appName: '',
                appUrl: '',
                appDescribe: '',
                appPrice: '',
                appType: undefined,
                openDate: undefined,
                tryTime: undefined,
                imgUrl: undefined,
            },
            detail: {
                visible: false,
                record: {},
                hasTable: true,
                tableTitle: '开通列表',
                tableData: [],
                tableCols: [
                    { label: '用户', prop: 'name' },
                    { label: '开通时间', prop: 'createDate', formatter: row => moment(row.createDate).format('YYYY-MM-DD HH:mm:ss') },
                    { label: '到期时间', prop: 'endTime', formatter: row => moment(row.endTime).format('YYYY-MM-DD HH:mm:ss') },
                    { label: '开通版本', prop: 'openVersion', formatter: row => openVersionDict[row.openVersion] },
                    { label: '应用状态', prop: 'payStatus', formatter: row => payStatusDict[row.payStatus] },
                ]
            },
            detailCols: [
                {
                    label: '应用名称',
                    prop: 'appName'
                },
                {
                    label: '发布时间',
                    prop: 'createDate',
                    formatter: (row) => moment(row.createDate).format('YYYY-MM-DD HH:mm:ss'),
                },
                {
                    label: '应用类型',
                    prop: 'appType',
                    formatter: (row) => row.appType ? this.options.find(it => it.value === row.appType).label : '-'
                },
                {
                    label: '服务商',
                    prop: 'serverName'
                },
                {
                    label: '已开通',
                    prop: 'appCount'
                },
            ],
            options: appTypeDict2,
            formInline: {
                type: ''
            },
            pagination: {
                currentPage: 1, // 当前页
                pageSize: 10, // 每页显示条数
                total: 0, // 总条数
                layout: 'total, prev, pager, next, jumper', // 分页布局
            },
            tableData: [],
            rules: {
                appName: [
                    { required: true, message: '请输入应用名称', trigger: 'blur' },
                ],
                appType: [
                    { required: true, message: '请选择应用类型', trigger: 'change' }
                ],
                imgUrl: [
                    { required: true, message: '请选择应用图标', trigger: 'change' }
                ],
                appUrl: [
                    { required: true, message: '请输入应用地址', trigger: 'blur' }
                ],
                appDescribe: [
                    { required: true, message: '请输入应用简介', trigger: 'blur' }
                ],
                appPrice: [
                    { required: true, message: '请输入应用价格（元）', trigger: 'blur' }
                ],
                openDate: [
                    { required: true, message: '请选择开通时长', trigger: 'change' }
                ],
                tryTime: [
                    { required: true, message: '请选择试用时长', trigger: 'change' }
                ],
            }
        };
    },

    mounted() {
        this.loadData()
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    },
    watch: {
        drawer: {
            handler(newVal) {
                if (newVal) {
                    getAppIconList({
                        filePrefix: 'application-image'
                    }).then(res => {
                        this.iconList = res.data
                    })
                }
            },
            deep: true
        },
    },
    methods: {
        // 新增-提交
        submitAdd(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    this.loading = true
                    const params = {
                        dataType: 3,
                        memberId: 0,
                    }
                    await getAddApp({
                        ...this.drawerForm,
                        ...params,
                        appType: Number(this.drawerForm.appType),
                        detailUrl: this.html
                    }).then(() => {
                        this.$message.success('新增应用成功')
                        this.drawer = false
                        this.loadData()
                        this.loading = false
                        this.drawerForm = {}
                        this.html = ''
                    }).catch(() => {
                        this.loading = false
                    })
                } else {
                    return false;
                }

            })


        },
        cancelForm() {
            this.drawer = false
            this.drawerForm = {}
            this.html = ''
        },
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
        // 新增
        onAdd() {
            this.drawer = true
        },
        // 查看
        onCancel() {
            this.detail.visible = false
        },
        handleStartOrStop(row) {
            let method = getAppInfoOn
            const params = {}
            if (row.status === 0) { // 已上架--需要下架 
                method = getAppInfoOff
                params.onAppId = row.appId
            } else { // 已下架--需要上架 
                method = getAppInfoOn
                params.appId = row.appId
                params.memberId = row.memberId
            }
            method(params).then(() => {
                this.$message.success(`${row.status === 0 ? '下架' : '上架'}成功`)
                this.loadData()
            })
        },
        handleDelete(row) {
            getAppInfoDel({
                id: row.id
            }).then(() => {
                this.$message.success('删除成功')
                this.loadData()
            })
        },
        // 时间转换
        dateFormat(row) {
            return moment(row.createDate).format('YYYY-MM-DD HH:mm:ss');
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },
        async handleClick(row) {
            await getAppInfoDetail({
                pageNo: 0,
                pageSize: 50,
                appId: row.appId
            }).then(res => {
                this.detail.tableData = res.data.content
                this.detail.visible = true
                this.detail.record = row
            })
        },
        onSubmit() {
            this.pagination.currentPage = 1
            this.loadData()
        },
        async loadData() {
            this.tableLoading = true
            const params = {}
            if (this.formInline.appName) {
                params.appName = this.formInline.appName
            }
            if (this.formInline.type) {
                params.type = this.formInline.type
            }
            await getAppInfoList({
                ...params,
                pageNo: this.pagination.currentPage - 1,
                pageSize: this.pagination.pageSize,
            }).then(res => {
                this.tableLoading = false
                this.tableData = res.data.content
                this.pagination.total = res.data.totalElements
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.consult-container {
    background: #fff;
    padding: 24px 0;

    .search-container {
        padding: 0 16px;
        border-bottom: 1px solid #EBEEF5;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .table-container {
        padding: 16px;
    }

    .pagination-container {
        margin-top: 16px;
        text-align: right;
    }

    .drawer-footer {
        text-align: center;
    }

    .mx-10 {
        margin: 0 10px;
    }

    ::v-deep .el-drawer__body {
        padding: 0 16px;
    }

    .app-icon {
        .el-radio.is-bordered {
            height: 64px;
            margin-left: 10px;
        }

        ::v-deep .el-radio__input {
            top: -24px;
        }

        img {
            position: relative;
            top: -5px;
        }
    }

}
</style>
<style lang="scss">
.el-popconfirm__main {
    margin: 10px 0;
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>